/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Outcome_Excess_And_ShortageInputs */

const en_inbound_outcome_excess_and_shortage = /** @type {(inputs: Inbound_Outcome_Excess_And_ShortageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Units in more and missing`)
};

/**
* | output |
* | --- |
* | "Units in more and missing" |
*
* @param {Inbound_Outcome_Excess_And_ShortageInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_outcome_excess_and_shortage = /** @type {((inputs?: Inbound_Outcome_Excess_And_ShortageInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Outcome_Excess_And_ShortageInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_outcome_excess_and_shortage(inputs)
});